module.exports = "/_next/static/images/6b4935ad0673f003f33f65c9bd837b52-background@1x.png.webp";